<template>
  <d-modal
    v-if="showModal"
    :key="'is-visible-' + showModal"
    style="background-color: rgba(0,0,0,0.6)!important; width: 110%; margin-left: -5%"
    class="crm-new-popup institution-prices">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template>Płatności ekspresowe</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-row
        no-gutters
        class="page-header pb-4">
        <d-col
          col
          sm="12"
          class="mb-4 mb-sm-0">
          <h3 class="page-title">Niektóre płatności zostały przekazane na spłatę wcześniejszych zadłużeń</h3>
        </d-col>
        <d-col
          col
          sm="12"
          class="my-3">
          <p class="my-0">
            Płatności przekazywane są na spłatę najstarszych, nieopłaconych zamówień.
          </p>
        </d-col>
        <d-col
          col
          sm="12">
          <p
            col
            sm="12"
            class="text-success font-weight-light h4 mt-3">Płatności zaliczone jako spłaty starszych zamówień:</p>
        </d-col>
      </d-row>

      <d-card
        style="width: 100%;"
        class="mb-2">
        <table class="table mt-0 mb-3 full-width">
          <thead class="bg-light">
            <tr>
              <th
                scope="col"
                class="border-0">Klient</th>
              <th
                scope="col"
                class="border-0">Sklep</th>
              <th
                scope="col"
                class="border-0 text-right">Wpłata</th>
              <th
                scope="col"
                class="border-0 text-right">Na poczet zaznaczonego zamówienia</th>
              <th
                scope="col"
                class="border-0 text-right">Zadłużenie klienta</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) of differentPayments"
              :key="'row-' + index">
              <td class="align-middle">
                {{ item.order_customer_name }}
              </td>
              <td class="align-middle">
                {{ item.order_shop_name}}
              </td>
              <td class="text-right text-primary">
                {{ item.paid_amount.toFixed(2) }} zł
              </td>
              <td class="text-right">
                {{ item.selected_order_amount.toFixed(2) }} zł
              </td>
              <td class="text-right">
                <span :class="item.customer_dept ? 'text-danger' : 'text-success'">
                  {{ item.customer_dept}} zł
                </span>
              </td>
            </tr>
            <tr v-if="!differentPayments.length">
              <td
                colspan="5"
                class="text-center">
                Brak elementów do wyświetlenia&hellip;
              </td>
            </tr>
          </tbody>
        </table>
      </d-card>

      <div class="popup-box-buttons pb-3 pt-5">
        <d-button
          theme="success"
          class="text-nowrap"
          @click.prevent="closeModal">
          Zamknij listę
        </d-button>
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'orders-bulk-payment-info',
  data () {
    return {};
  },
  props: {
    closeModal: {
      required: true,
      type: Function
    },
    differentPayments: {
      required: true,
      type: Array
    },
    showModal: {
      required: true,
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
  .popup-box-buttons {
    justify-content: center;
    button {
      width: 50%;
    }
  }
</style>
